import NewsCategory from '../../../api/newsCategoryEntity';
import {newsContentManager} from '../../../api/newsContentManager';
import NewsItemDto from '../../../api/newsItemDto';
import { notifyBreadcrumChangeAction } from '../../../common/components/breadcrumb/actions/notifyBreadcrumChange';
import { actionTypes } from '../../../common/constants/actionTypes';

import { httpCallStartAction } from '../../../middlewares/http/actions';

export const fetchArchivePageNewsItemsAction = (query?: object) => (dispatch: any) => {
    dispatch(httpCallStartAction());

  newsContentManager.fetchArchivePageNewsItemsAsync(query)
    .then((newsItems) => {
      dispatch(fetchArchivePageNewsItemsCompleted(newsItems));
      dispatch(notifyBreadcrumChangeAction(actionTypes.BREADCRUMB_CHANGED_ON_ARCHIVE_PAGE, "Uutisarkisto"));
    });
};

export const fetchNewsCategoriesAction = () => (dispatch: any) => {
  dispatch(httpCallStartAction());

newsContentManager.fetchNewsCategoriesAsync()
  .then((newsCategories) => {
    dispatch(fetchNewsCategoriesCompleted(newsCategories));
    dispatch(notifyBreadcrumChangeAction(actionTypes.BREADCRUMB_CHANGED_ON_ARCHIVE_PAGE, "Uutisarkisto"));
  });
};
export const fetchArchivePageNewsItemsByCategoryAction = (categories: string, query?: object) => (dispatch: any) => {
  dispatch(httpCallStartAction());

newsContentManager.fetchArchivePageNewsItemsByCategoryAsync(categories, query)
  .then((newsItems) => {
    dispatch(fetchArchivePageNewsItemsCompleted(newsItems));
      dispatch(notifyBreadcrumChangeAction(actionTypes.BREADCRUMB_CHANGED_ON_ARCHIVE_PAGE, "Uutisarkisto"));
  })
  .catch(error => dispatch(handleError(error)));;
};


const fetchArchivePageNewsItemsCompleted = (newsItems: NewsItemDto) => ({
    meta: {
        httpEnd: true,
      },
    payload: newsItems,
    type: actionTypes.FETCH_NEWS_ITEMS
});

const fetchNewsCategoriesCompleted = (newsCategories: NewsCategory[]) => ({
  meta: {
      httpEnd: true,
    },
  payload: newsCategories,
  type: actionTypes.FETCH_NEWS_CATEGORIES_COMPLETED
});

const handleError = (reason: any) => ({
  meta: {
      httpEnd: true,
    },
  payload: {message: reason.message, hasError: true},
  type: actionTypes.FETCH_CONTENT_PAGE_ERROR
});


// WEBPACK FOOTER //
// ./src/components/archiveNewsPage/actions/fetchArchivePageNewsItems.ts